<div class="pb-30 pt-70 school-invites">
  <div class="container">
    <div class="row">
      <app-article [pageName]="'FIND_NEW_SCHOOLS'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
      <div class="col-lg-8 col-md-12">
        <h4 class="mb-20">Find new schools</h4>
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link" [ngClass]="{ active: activeTab === 'invites' }" (click)="onTabChange('invites')"
              id="nav-invite-tab" data-bs-toggle="tab" data-bs-target="#nav-invite" type="button" role="tab"
              aria-controls="nav-invite" aria-selected="true">
              All Schools
            </button>
            <button class="nav-link" [ngClass]="{ active: activeTab === 'pending' }" (click)="onTabChange('pending')"
              id="nav-pending-tab" data-bs-toggle="tab" data-bs-target="#nav-pending" type="button" role="tab"
              aria-controls="nav-pending" aria-selected="false">
              Pending
            </button>
            <button class="nav-link" [ngClass]="{ active: activeTab === 'history' }" (click)="onTabChange('history')"
              id="nav-history-tab" data-bs-toggle="tab" data-bs-target="#nav-history" type="button" role="tab"
              aria-controls="nav-history" aria-selected="false">
              History
            </button>
          </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show" [ngClass]="{ active: activeTab === 'invites' }" id="nav-invite"
            role="tabpanel" aria-labelledby="nav-invite-tab">
            <form [formGroup]="schoolInvitesFilterForm">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <label for="search_by_name" id="search_by_name_label">Search by school name</label>
                  <input id="search_by_name" aria-label="Search by school name" aria-labelledby="search_by_name_label"
                    formControlName="title" type="text" class="form-control" (change)="loadOnFilter()" />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <label for="search_by_post_code" id="search_by_post_code_label">Search by post code</label>
                  <input id="search_by_post_code" aria-label="Search by post code"
                    aria-labelledby="search_by_post_code_label" formControlName="pincode" type="text"
                    class="form-control" (change)="loadOnFilter()" />
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-floating flex-fill left-labeled">
                    <label for="distance">Distance</label>
                    <select id="distance" name="distance" formControlName="distance" class="form-select mb-6 c-p"
                      aria-label="Search by distance" (change)="loadOnFilter()">
                      <option *ngFor="let distance of distance_choice" [value]="distance.value">
                        {{ distance.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-floating flex-fill left-labeled">
                    <label for="school_level">School level</label>
                    <select id="school_level" formControlName="school_level" name="school_level"
                      class="form-select mb-6 c-p" aria-label="Search by school level" (change)="loadOnFilter()">
                      <option *ngFor="let level of school_level" [value]="level.value">
                        {{ level.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-floating flex-fill left-labeled">
                    <label for="school_type">School type</label>

                    <select id="school_type" formControlName="school_type" name="school_type"
                      class="form-select mb-6 c-p" aria-label="Search by school type" (change)="loadOnFilter()">
                      <option *ngFor="let type of school_type" [value]="type.value">
                        {{ type.title }}
                      </option>
                    </select>
                  </div>
                </div>
                @if(teacherData.properties.is_qld_teacher){
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-floating flex-fill left-labeled">
                    <label for="region_filter">Region</label>

                    <select id="region_filter" formControlName="region" name="region_filter"
                      class="form-select mb-6 c-p" aria-label="Search by region" (change)="loadOnFilter()">
                      <option *ngFor="let region of region_choice" [value]="region.value">
                        {{ region.title }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-floating flex-fill left-labeled">
                    <label for="sector_filter">Group</label>

                    <select id="sector_filter" formControlName="group" name="sector_filter" class="form-select mb-6 c-p"
                      aria-label="Search by sector" (change)="loadOnFilter()">
                      <option *ngFor="let group of groupChoice" [value]="group.value">
                        {{ group.title }}
                      </option>
                    </select>
                  </div>
                </div>
                }
                <div class="col-lg-4 col-md-4 col-sm-12 mt-20 form-floating">
                  <div class="form-check">
                    <input aria-labelledby="new_school_label" role="checkbox" aria-label="New School"
                      class="form-check-input c-p mt-4" (change)="loadOnFilter()" appClick appFocus type="checkbox"
                      id="new_school" formControlName="new_school">
                    <label class="form-check-label c-p ml-2" id="new_school_label" for="new_school">
                      New Schools
                    </label>
                  </div>
                </div>
              </div>
            </form>

            @if (invitesData.length != 0) {
            <div>
              @if (invitesSchoolsList | async; as pendinglist) {
              <!-- <div class="row mt-20 sub-header align-items-center">
                <div class="col-lg-4 col-md-4">
                  <input appFocus appClick #checkAll [(ngModel)]="selectAllCheck" class="form-check-input mt-0 mr-5"
                    id="checkAll" type="checkbox" (change)="selectAll('All', $event)" 
                    >
                  <span class="text-r-m-16">{{schoolDetails.length}} matches found</span>
                </div>
                <div class="col-lg-8 col-md-8 text-regular-medium pl-10" [ngClass]="hideButton ? 'input-cursor-na' : ''">
                  <div class="d-flex align-items-center justify-content-end">
                    <a role="button" appClick [appFocus]="hideButton ? '-1' : '0'" aria-label="Accept Selected"
                      class="h_b c-p d-flex align-items-center ml-10 clr-cc-vilot text-regular-bold"
                      (click)="OpenAccepetRequestModal('', false,'')" [ngClass]="hideButton ? 'disabled' : ''">
                      <i class="bi bi-check-lg fs-19 me-1"></i> Request selected
                    </a>
                  </div>
                </div>
              </div> -->

              <div>
                @for (item of invitesData; track item; let i = $index) {
                <div class="card mt-10 px-15">
                  <div class="row align-items-center">

                    <div class="col-lg-7 col-md-7 col-12">
                      <div class="d-flex">

                        <div class="pic-and-check ml-0">
                          <img [src]="
              item.profile_image
                ? item.profile_image
                : '../../../../assets/images/teacher-static-profile.png'
            " class="profile-picture img-complete-match" alt="School logo" />
                        </div>

                        <div class="pic-and-check ml-10">

                          <h6 class="text-regular-bold fs-16 mb-0" [id]="'schoolTitle_' + i">
                            {{ item.title }}
                          </h6>

                          @if(item?.sub_group_accept) {
                          <p class="txt-regular grey-2" [id]="'subGroup_' + i"
                            [attr.title]="item?.sub_group?.sub_group_name">
                            {{ item?.sub_group?.sub_group_name }}
                          </p>
                          }

                          <div class="clr-grey-3 txt-regular">

                            <p class="txt-regular grey-2" [id]="'location_' + i">
                              <span>
                                {{ item.address.address_timezone.state }},
                                {{ item.address.address_timezone.country }} - {{ item.address.postal_code }}
                              </span>
                              | <span>{{ item.distance }} km</span>
                            </p>

                            <p [id]="'phone_' + i">
                              <span class="grey-2">School Contact: </span>
                              {{ item.phone_number }}
                            </p>

                            <p [id]="'email_' + i">
                              <span class="grey-2">Email: </span>
                              {{ item.email }}
                            </p>

                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="col-lg-5 col-md-5 text-end" [ngClass]="hideButton ? '' : 'input-cursor-na'">

                      <div class="accept-decline">

                        <!-- VIEW PROFILE BUTTON -->

                        <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'"
                          class="text-regular-bold btn-outline clr-cc-vilot c-p me-2"
                          (click)="viewAsTeacher(item?.slug)" [attr.aria-describedby]="
            'schoolTitle_' + i + ' ' +
            'subGroup_' + i + ' ' +
            'location_' + i + ' ' +
            'phone_' + i + ' ' +
            'email_' + i
          " aria-label="View school profile">
                          View Profile
                        </button>
                        @if(item.is_connect_school){
                        <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'" class="cc_p_btn fs-14"
                          (click)="addtoSchool(item)">
                          Connect with school
                        </button>
                        }@else{
                        @if(item?.request_pending){

                        <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'"
                          class="cc_p_btn disabled fs-14" [attr.aria-describedby]="
            'schoolTitle_' + i + ' ' +
            'location_' + i
          ">
                          Request Pending
                        </button>

                        }@else if(!item?.request_pending){

                        <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'" class="cc_p_btn fs-14"
                          (click)="
            OpenAccepetRequestModal(
              item?.id,
              item?.sub_group_accept,
              item?.title,
              item?.group?.group_name,
              item?.sub_group?.sub_group_name,
              item,
              item.group
            )
          " [attr.aria-describedby]="
            'schoolTitle_' + i + ' ' +
            'subGroup_' + i + ' ' +
            'location_' + i + ' ' +
            'phone_' + i + ' ' +
            'email_' + i
          " aria-label="Send request to school">
                          Send Request
                        </button>

                        }
                        }
                      </div>
                    </div>

                  </div>
                </div>
                }
                <div class="row">
                  <div class="col-lg-12">
                    <pagination *ngIf="invitesData.length > 0" class="mt-20" [ngModelOptions]="{ standalone: true }"
                      [totalItems]="totalCount" class="pagination-sm mt-20" [boundaryLinks]="true" [rotate]="true"
                      [maxSize]="10" [(ngModel)]="schoolInvitesFilterForm.value.page"
                      (pageChanged)="pageChanged($event)">
                    </pagination>
                  </div>
                </div>
              </div>
              }
            </div>

            } @if (invitesData.length == 0) {
            <div class="card px-30 mt-20">
              <div class="text-center mt-20">
                <p>
                  <img style="width: 200px;" src="assets/images/CCPI_PendingRequests_NoAcceptedRequests-021.png"
                    alt="No schools found!" />
                </p>
                <p class="title">No schools found.</p>
              </div>
            </div>
            }
          </div>

          <!-- Pending Tab -->
          <div class="tab-pane fade" id="nav-pending" [ngClass]="{ active: activeTab === 'pending' }" role="tabpanel"
            aria-labelledby="nav-pending-tab">
            <div class="mt-20">
              <form [formGroup]="schoolInvitesPendingFilterForm">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-10 form-floating">
                    <label for="search_by_name_pending" id="search_by_name_pending_label">Search by school
                      name</label>
                    <input id="search_by_name_pending" aria-label="Search by name"
                      aria-labelledby="search_by_name_pending_label" formControlName="title" type="text"
                      class="form-control" (change)="getFilterInputs()" />
                  </div>
                </div>
              </form>

              @if (pendingData.length != 0) { @if (pendingSchoolsList | async;
              as pendingSubject) {
              <div class="mt-20">
                @for (item of pendingData; track item; let i = $index) {
                <div class="card mt-10 px-15">
                  <div class="row align-items-center">
                    <div class="col-lg-7 col-md-7 col-11">
                      <div class="d-flex">
                        <div class="pic-and-check ml-0">
                          <img alt="img" [src]="
                              item?.school?.profile_image
                                ? item?.school?.profile_image
                                : '../../../../assets/images/teacher-static-profile.png'
                            " class="profile-picture img-complete-match" />
                        </div>
                        @if(item?.school?.title != null) {
                        <div class="pic-and-check ml-10">
                          <h6 class="text-regular-bold fs-16 mb-0">
                            {{ item?.school?.title }}
                          </h6>

                          <div class="clr-grey-3 txt-regular">
                            <p class="txt-regular grey-2">
                              <span>{{
                                item?.school?.address?.address_timezone
                                ?.state
                                }},
                                {{
                                item?.school?.address?.address_timezone
                                ?.country
                                }} - {{ item?.school?.address?.postal_code }}</span>
                              | <span>{{ item?.distance }} km</span>
                            </p>
                            <p>
                              <span class="grey-2">School Contact: </span>
                              {{ item?.school?.phone_number }}
                            </p>
                            <!-- <p><span class="grey-2">Email: </span>{{item?.school?.email}}</p> -->
                          </div>
                        </div>
                        }@else {
                        <div class="pic-and-check ml-10">
                          <h6 class="text-regular-bold fs-16 mb-0">
                            {{ item?.sub_group?.sub_group_name }}
                          </h6>
                          <div class="clr-grey-3 txt-regular">
                            <p class="txt-regular">
                              {{ item?.sub_group?.hover_text }}
                            </p>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-5 text-end" [ngClass]="hideButton ? '' : 'input-cursor-na'">
                      <div class="accept-decline">
                        <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'" class="cc_p_btn fs-14"
                          (click)="openCancelRequestModal(item.id)">
                          Cancel
                        </button>
                      </div>
                      <p class="txt-regular grey-2 mt-10 fs-12">
                        Requested on {{ item?.updated_at }}
                      </p>
                    </div>
                  </div>
                </div>
                }
              </div>
              } } @if (pendingData.length == 0) {
              <div class="card px-30 mt-20">
                <div class="text-center mt-20">
                  <p>
                    <img style="width: 200px;" src="assets/SmartGroups_NoBackupList.png" alt="No invites found!" />
                  </p>
                  <p class="title pl-50 pr-50 mt-20">
                    You have not sent any requests to schools yet. Send a request from the All schools tab to see them
                    here.
                  </p>

                </div>
              </div>
              }
            </div>
          </div>
          <!-- History Tab -->
          <div class="tab-pane fade" id="nav-history" [ngClass]="{ active: activeTab === 'history' }" role="tabpanel"
            aria-labelledby="nav-history-tab">
            <div class="mt-20">
              <form [formGroup]="schoolInvitesHistoryFilterForm">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-10 form-floating">
                    <label for="search_by_name_history" id="search_by_name_history_label">Search by school
                      name</label>
                    <div class="d-flex">
                      <input id="search_by_name_history" aria-label="Search by name"
                        aria-labelledby="search_by_name_history_label" formControlName="title" type="text"
                        class="form-control" (change)="getFilterInputs()" />
                    </div>
                  </div>
                </div>
              </form>

              @if (historyData.length != 0) { @if (invitesHistorySchoolsList |
              async; as pendingHistory) {

              <div class="mt-20">
                @for (item of historyData; track item; let i = $index) {
                <div class="card mt-10 px-15">
                  <div class="row align-items-center">
                    <div class="col-lg-7 col-md-7 col-11">
                      <div class="d-flex">
                        <!-- <div class="pic-and-check">
                            <input appClick class="form-check-input mr-10 c-p" type="checkbox"
                              (change)="selectAll(item, $event)" [checked]="item?.isChecked"
                              [attr.id]="item?.schools?.id" [attr.aria-label]="item?.schools?.rta_user?.full_name">
                          </div> -->
                        <div class="pic-and-check ml-0">
                          <img alt="img" [src]="
                              item?.school?.profile_image
                                ? item?.school?.profile_image
                                : '../../../../assets/images/teacher-static-profile.png'
                            " class="profile-picture img-complete-match" />
                        </div>
                        <div class="pic-and-check ml-10">
                          <h6 class="text-regular-bold fs-16 mb-0">
                            {{ item?.school?.title }}
                          </h6>
                          <div class="clr-grey-3 txt-regular">
                            <p class="txt-regular grey-2">
                              <span>{{
                                item?.school?.address?.address_timezone
                                ?.state
                                }},
                                {{
                                item?.school?.address?.address_timezone
                                ?.country
                                }} - {{ item?.school?.address?.postal_code }}</span>
                              | <span>{{ item?.distance }} km</span>
                            </p>
                            <p>
                              <span class="grey-2">School Contact: </span>
                              {{ item?.school?.phone_number }}
                            </p>
                            <!-- <p><span class="grey-2">Email: </span>{{item?.school?.email}}</p> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-5 text-end" [ngClass]="hideButton ? '' : 'input-cursor-na'">
                      <div class="accept-decline">
                        @if(item?.status == 'RDS'){
                        <p class="user-title-m clr-red">Declined</p>
                        }@else if(item?.status == 'PC'){
                        <p class="user-title-m clr-green">Accepted</p>
                        }@else if(item?.status == 'PS'){
                        <p class="user-title-m clr-blue">Cancelled</p>
                        }@else if(item?.status == 'GAP'){
                        <p class="user-title-m clr-blue">Cancelled</p>
                        }
                        <p class="txt-regular grey-2">
                          on {{ item?.updated_at }}
                        </p>
                        @if(item?.status == 'RDS'){
                        <p class="user-title-m clr-cc-vilot">
                          Reason for decline {{ item?.decline_reason }}
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
              } } @if (historyData.length == 0) {
              <div class="card px-30 mt-20">
                <div class="text-center mt-20">
                  <p>
                    <img style="width: 200px;" src="assets/PreBooking_NoMatchesFound_Post copy.png"
                      alt="No invites found!" />
                  </p>
                  <p class="title pl-50 pr-50 mt-20">
                    No request has been accepted/declined by schools yet. Send a request from the All schools tab to see
                    them here.
                  </p>

                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Right Sidebar -->
      <div class="col-lg-4 col-md-12">
        <div class="card px-15">
          <div class="row align-items-center">
            <app-complete-profile-chart [profilePercentage]="teacherProfile"></app-complete-profile-chart>
          </div>
        </div>
        <div class="card px-15 mt-20">
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <h5 class="user-title fs-18">School requests</h5>
              <p class="txt-regular mt-5 grey-2">
                Your requests reset at the start of every week.
              </p>
              <div class="d-flex align-items-center">
                <div>
                  <h2 class="mb-0 text-regular-medium fs-32 clr-cc-vilot">
                    {{pageDetails?.week_invites}}/{{pageDetails?.weekly_invite_limit}}</h2>
                </div>
                <div>
                  <p class="txt-regular fs-16 ml-10">Requests</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card px-15 mt-20">
          <h5 id="referSchoolTitle" class="user-title fs-18 mb-0 mt-3">
            Refer a school & get rewarded
          </h5>
          <p id="referSchoolDesc" class="txt-regular mt-5 mb-5">
            Refer a school that you know that isn’t on the list above and get
            rewarded.
          </p>
          <a appFocus href="https://rtcon.typeform.com/to/i7ildpN3?typeform-source=app.classcover.com.au"
            target="_blank" aria-labelledby="referSchoolTitle" aria-describedby="referSchoolDesc"
            class="clr-cc-vilot fs-16 text-regular-bold" role="button">
            Refer a school
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
              viewBox="0 0 16 17">
              <path fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
          </a>
        </div>
        <div class="card px-15 mt-20">
          <h5 id="jobAlertsTitle" class="user-title fs-18 mb-0 mt-3">Hear about new jobs</h5>
          <p id="jobAlertsDesc" class="txt-regular mt-5 mb-5">
            Be the first to hear about new jobs that match your preferences.
          </p>
          <a appFocus (click)="goToSettingsPage()" aria-labelledby="jobAlertsTitle" aria-describedby="jobAlertsDesc"
            class="clr-cc-vilot fs-16 text-regular-bold" role="button">
            Set up job alerts
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
              viewBox="0 0 16 17">
              <path fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #acceptRequestModal>
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel">Confirmation</h4>
    <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
  </div>

  <div class="modal-body pb-0">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div *ngIf="subGroupAccept; else defaultMsg">
          <p class="txt-regular">
            <b>{{ schoolName }}</b> is part of the <b>{{ subGroupName }}</b> which is part of the <b>{{ groupName
              }}</b>. Would you like to request to be part of the region to be booked
            by schools within it?
          </p>
        </div>
        <ng-template #defaultMsg>
          <p class="txt-regular">
            Are you sure you want to send a request to join this school?
          </p>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-10">
    <div *ngIf="subGroupAccept; else defaultbtn">
      <button type="button" (click)="sendRequest(singleSelectedSchoolId, false)" class="btn-outline fs_13 mr-10">
        Request {{ schoolName }}
      </button>
      <button type="button" (click)="sendRequest(singleSelectedSchoolId, true)" class="cc_p_btn fs_13">
        Request all Schools
      </button>
    </div>
    <ng-template #defaultbtn>
      <button type="button" (click)="sendRequest(singleSelectedSchoolId, false)" class="cc_p_btn fs_13">
        Confirm
      </button>
    </ng-template>
  </div>
</ng-template>
<ng-template #cancelRequestModal>
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel">Confirmation</h4>
    <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
  </div>
  <div class="modal-body pb-0">
    <div class="row align-items-center">
      <div class="col-md-12">
        <p class="txt-regular">Are you sure you want to cancel the request?</p>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-10">
    <button type="button" (click)="cancelInvite(singleSelectedSchoolId)" class="cc_p_btn fs_13">
      Confirm
    </button>
  </div>
</ng-template>

<ng-template #setPreferenceModalTemplate>
  <div class="modal-header">
    <h5 class="modal-title">Set Preferences for {{schoolData?.title}}</h5>
    <button type="button" class="btn-close" (click)="loadInvites();this.bsModalRef.hide()" aria-label="Close"></button>
  </div>

  <div class="modal-body pb-0">
    <form [formGroup]="preferenceForm">
      <h3>Preferred year level</h3>
      <div class="row">
        <div *ngFor="let level of yearLevels" class="col-6">
          <label>
            <input type="checkbox" name="preferred_year_level" class="form-check-input me-1" [value]="level.value"
              (change)="onYearLevelChange($event)"
              [checked]="preferenceForm.value.preferred_year_level.includes(level.value)" />
            {{ level.label }}
          </label>
        </div>
      </div>

      <!-- ✅ Error for Preferred Year -->
      <div class="text-danger mt-1"
        *ngIf="preferenceForm.get('preferred_year_level')?.touched &&preferenceForm.get('preferred_year_level')?.invalid">
        Please select at least one preferred year level.
      </div>

      <h3 class="mt-8">Work type preferences</h3>
      <div>
        <label>
          <input type="checkbox" class="form-check-input me-1" value="C" (change)="onWorkTypeChange($event)"
            [checked]="preferenceForm.value.work_type.includes('C')" />
          Casual
        </label>

        <label class="ms-3">
          <input type="checkbox" name="work_type" class="form-check-input" value="T" (change)="onWorkTypeChange($event)"
            [checked]="preferenceForm.value.work_type.includes('T')" />
          Temporary/Contract
        </label>
      </div>

      <!-- ✅ Error for Work Type -->
      <div class="text-danger mt-1"
        *ngIf="preferenceForm.get('work_type')?.touched &&preferenceForm.get('work_type')?.invalid">
        Please select at least one work type.
      </div>

    </form>


  </div>

  <hr class="mt-10 mb-10" />

  <div class="modal-footer justify-content-end">
    <button type="button" class="btn cc_p_btn fs_13" (click)="saveSchoolPreferences()"
      [disabled]="preferenceForm.invalid">
      Save
    </button>
  </div>
</ng-template>